import { createFileRoute } from '@tanstack/react-router';
import { HOLIDAY_TABS, type HolidayTab } from '@/pages/Time/holiday-tabs';
import { parseScopeParam, type ScopeParam } from '@/pages/Time/acting-tenant';

/**
 * `?tab=` keeps a known tab (the page resolves the persona's landing tab otherwise) and `?scope=` is the agency client scope of
 * the Calendars tab (LPH-T35 FR-11): `own`, `all` or a client tenant id, anything else `own`. Both optional; every other key is
 * returned untouched.
 */
export const Route = createFileRoute('/time/holidays')({
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & { tab?: HolidayTab; scope?: ScopeParam } => ({
    ...search,
    tab: (HOLIDAY_TABS as readonly unknown[]).includes(search.tab) ? (search.tab as HolidayTab) : undefined,
    scope: search.scope === undefined ? undefined : parseScopeParam(search.scope),
  }),
});
